import { createRoute } from '../commons/utils/route-helper';
import { ROUTE } from './route-definition.model';

class RouteService {
  public getLoginPath(): string {
    return ROUTE.LOGIN;
  }

  public getStatisticsPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.STATISTIC}`;
  }

  public getUserWatchlistPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.USER_WATCHLIST}`;
  }

  public getCreditPackageOrderPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.CREDIT_PACKAGE_ORDER}`;
  }

  public getSystemWalletPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.SYSTEM_WALLET}`;
  }

  public getCreditPackageManagementPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.CREDIT_PACKAGE_MANAGEMENT}`;
  }

  public getServiceTagManagementPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.SERVICE_TAG_MANAGEMENT}`;
  }

  public getShortenedLinkPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.SHORTENED_LINK}`;
  }

  public getCustomerCsvImportPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.IMPORT_CUSTOMER_CSV}`;
  }

  public getLexofficePath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.LEXOFFICE}`;
  }

  public getInvoiceJobPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.INVOICE_JOB}`;
  }

  public getFlyerCampaignPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.FLYER_CAMPAIGN}`;
  }

  public getUsersPath(): string {
    return `/${ROUTE.PRIVATE}/${ROUTE.USER}`;
  }

  public getUserCreatePath(): string {
    return `${this.getUsersPath()}/${ROUTE.USER_CREATE}`;
  }

  public getUserDetailPath(): string {
    return `${this.getUsersPath()}/${ROUTE.USER_DETAIL}`;
  }

  public getAndFillUserDetailPath(userId: number): string {
    return createRoute(this.getUserDetailPath(), { userId });
  }

  public getBusinessObjectsPath(): string {
    return `${this.getUserDetailPath()}/${ROUTE.BUSINESS_OBJECT}`;
  }

  public getAndFillBusinessObjectsPath(userId: number): string {
    return createRoute(this.getBusinessObjectsPath(), { userId });
  }

  public getBusinessObjectDetailPath(): string {
    return `${this.getBusinessObjectsPath()}/${ROUTE.BUSINESS_OBJECT_DETAIL}`;
  }

  public getAndFillBusinessObjectDetailPath(userId: number, boId: number): string {
    return createRoute(this.getBusinessObjectDetailPath(), { userId, boId });
  }

  public getBusinessObjectCreatePath(): string {
    return `${this.getBusinessObjectsPath()}/${ROUTE.BUSINESS_OBJECT_CREATE}`;
  }

  public getAndFillBusinessObjectCreatePath(userId: number): string {
    return createRoute(this.getBusinessObjectCreatePath(), { userId });
  }

  public getCategoriesPath(): string {
    return `${this.getBusinessObjectDetailPath()}/${ROUTE.CATEGORY}`;
  }

  public getAndFillCategoriesPath(userId: number, boId: number): string {
    return createRoute(this.getCategoriesPath(), { userId, boId });
  }

  public getCategoryDetailPath(): string {
    return `${this.getCategoriesPath()}/${ROUTE.CATEGORY_DETAIL}`;
  }

  public getAndFillCategoryDetailPath(userId: number, boId: number, categoryId: number): string {
    return createRoute(this.getCategoryDetailPath(), { userId, boId, categoryId });
  }

  public getCategoryMassiveCreatePath(): string {
    return `${this.getCategoriesPath()}/${ROUTE.MASSIVE_CREATE}`;
  }

  public getAndFillCategoryMassiveCreatePath(userId: number, boId: number): string {
    return createRoute(this.getCategoryMassiveCreatePath(), { userId, boId });
  }

  public getCategoryCreatePath(): string {
    return `${this.getCategoriesPath()}/${ROUTE.CATEGORY_CREATE}`;
  }

  public getAndFillCategoryCreatePath(userId: number, boId: number): string {
    return createRoute(this.getCategoryCreatePath(), { userId, boId });
  }

  public getProductsPath(): string {
    return `${this.getCategoryDetailPath()}/${ROUTE.PRODUCT}`;
  }

  public getAndFillProductsPath(userId: number, boId: number, categoryId: number): string {
    return createRoute(this.getProductsPath(), { userId, boId, categoryId });
  }

  public getProductDetailPath(): string {
    return `${this.getProductsPath()}/${ROUTE.PRODUCT_DETAIL}`;
  }

  public getAndFillProductDetailPath(userId: number, boId: number, categoryId: number, productId: number): string {
    return createRoute(this.getProductDetailPath(), { userId, boId, categoryId, productId });
  }

  public getProductCreatePath(): string {
    return `${this.getProductsPath()}/${ROUTE.PRODUCT_CREATE}`;
  }

  public getAndFillProductCreatePath(userId: number, boId: number, categoryId: number): string {
    return createRoute(this.getProductCreatePath(), { userId, boId, categoryId });
  }
}

const routeService = new RouteService();

export default routeService;
